<template>
  <v-content>
    <v-row class="layout" wrap>
      <v-col cols="12">
        <h1 class="display-1">
          {{ $t("DOWNLOAD_HEADER") }}
        </h1>
      </v-col>
      <v-col class="downloadContent" cols="12">
        <div v-html="$t('DOWNLOAD_TEXT')"></div>
      </v-col>
      <v-col cols="12">
        <a :href="`/api/download/${code}/zip`" download>
          <v-btn color="primary">
            <v-icon>photo_library</v-icon>
            {{ $t("DOWNLOAD_BUTTON_ALL") }}
          </v-btn>
        </a>
      </v-col>
    </v-row>
    <v-row class="layout" wrap>
      <v-col v-for="image in images" :key="image.id" class="imageFlex">
        <v-card class="imageCard">
          <v-img
              :src="`/api/download/${code}/previewImage/${image.id}/large`"
              class="imagePreview"
              contain
              lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAN4AAADjCAMAAADdXVr2AAAAA1BMVEX///+nxBvIAAAASElEQVR4nO3BMQEAAADCoPVPbQdvoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOA8W9AAHiq1isAAAAAElFTkSuQmCC"></v-img>
          <v-card-actions class="actions">
            <v-spacer/>
            <a :href="`/api/download/${code}/image/${image.id}`" download>
              <v-btn color="primary">
                <v-icon>photo</v-icon>
                {{ $t("DOWNLOAD_BUTTON") }}
              </v-btn>
            </a>
            <v-spacer/>
          </v-card-actions>

        </v-card>
      </v-col>
    </v-row>
  </v-content>

</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {DownloadPackageApi, ImageDto} from "@swagger";
import {Prop, Watch} from "vue-property-decorator";

@Component({})
export default class ImageDownload extends BasicComponent {

  @Prop(String) code: string;

  images: ImageDto[] = [];

  created() {
    this.requestImages();
  }

  requestImages() {
    if (this.code == null) return;
    new DownloadPackageApi(this.apiConfiguration).listImages(this.code)
        .then((data: Array<ImageDto>) => {
          this.images = data;
        })
        .catch((err) => {
          console.error(err);
        });
  }

  @Watch("code")
  onCodeChanged(newVal, oldVal) {
    this.requestImages();
  }

}

</script>
<style lang="scss" scoped>

.layout {
  margin-top: 10px;
}

.downloadContent {
  margin-top: 25px;
}

.imageFlex {
  flex-grow: 0;

  .imageCard {
    width: 320px;
    max-width: 98%;
    margin: 4px;
    margin-right: 15px;
    display: inline-block;
    vertical-align: top;
    padding-bottom: 52px;

    .imagePreview {
      width: 300px;
      height: 300px;
      margin: 0 auto;

      max-width: 100%;
    }

    .productHeader {
      padding-bottom: 0;
    }

    .productShortDescription {
      padding-top: 0;
    }

    .actions {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
}

.downloadTable {

  border-collapse: collapse;
  border: none;

  width: 100%;

  td, th {
    border-bottom: 1px solid gray;

    &:not(:first-of-type) {
      border-left: 1px solid gray;
      padding-left: 20px;
    }
  }

  th {
    text-align: left;

    &:last-of-type {
      text-align: right;
    }
  }

  td {
    padding-top: 7px;
  }

  img {
    display: inline-block;
  }

  @media screen and (max-width: 740px) {
    th {
      display: none;
    }

    tr {
      display: flex;
      flex-wrap: wrap;

      td {
        display: block;

        border-bottom: none;
        width: 100%;
        flex-basis: 100%;
      }

      border-bottom: 1px solid black;
    }
  }
}

</style>
<style lang="scss">

</style>
